export type ReleaseNoteType = 'feature' | 'fix' | 'improvement';

export interface ReleaseNoteItem {
  type: ReleaseNoteType;
  text: string;
}

export interface ReleaseNote {
  version: string;
  date: string;
  title: string;
  items: ReleaseNoteItem[];
}

// Neue Einträge OBEN einfügen. Der oberste Eintrag ist immer "aktuell".
export const RELEASE_NOTES: ReleaseNote[] = [
  {
    version: '1.10.11',
    date: '2026-06-29T10:00:00',
    title: 'CRM-Zugriff: Neue Benutzer können sofort alle Module nutzen',
    items: [
      { type: 'fix', text: 'CRM: Neu angelegte Benutzer werden jetzt automatisch dem Mandanten zugewiesen — bisher musste dieser Schritt manuell nachgeholt werden, sonst erschien in CRM "... Konnte nicht angezeigt werden"' },
      { type: 'improvement', text: 'Benutzerverwaltung: Im Bearbeiten-Dialog wird die Mandant-Mitgliedschaft des Benutzers angezeigt und kann dort bei Bedarf nachträglich zugewiesen werden' },
    ],
  },
  {
    version: '1.10.10',
    date: '2026-06-22T10:00:00',
    title: 'Office 365 Persönliche Verbindung: Einrichtung funktioniert wieder',
    items: [
      { type: 'fix', text: 'Office 365 Integration: Beim Einrichten der persönlichen Verbindung (Einstellungen → Integrationen) erschien eine Fehlermeldung "Zugriff verweigert" — jetzt wird korrekt nach dem Microsoft-Konto gefragt' },
    ],
  },
  {
    version: '1.10.9',
    date: '2026-06-18T16:00:00',
    title: 'Office 365 Admin-Einwilligung: Fehler behoben',
    items: [
      { type: 'fix', text: 'SSO-Einstellungen: Beim Erteilen der Admin-Einwilligung erschien ein Microsoft-Fehler (AADSTS901001) — die Weiterleitung zu Microsoft nutzt jetzt den korrekten Endpunkt' },
    ],
  },
  {
    version: '1.10.8',
    date: '2026-06-18T14:00:00',
    title: 'Office 365 Admin-Einwilligung: Berechtigungsumfang präzisiert',
    items: [
      { type: 'fix', text: 'SSO-Einstellungen: Die Admin-Einwilligung deckt jetzt alle erforderlichen Berechtigungen (Mail, Kalender, Kontakte, Aufgaben) vollständig ab' },
    ],
  },
  {
    version: '1.10.7',
    date: '2026-06-17T10:00:00',
    title: 'Office 365 Integration für alle Benutzer freischaltbar',
    items: [
      { type: 'feature', text: 'SSO-Einstellungen: Neuer Button "Admin-Einwilligung erteilen" — Administratoren können die Office 365 Integration einmalig für die gesamte Organisation freischalten, sodass alle Benutzer sie ohne Fehlermeldung aktivieren können' },
      { type: 'improvement', text: 'SSO-Einrichtungsanleitung: Alle benötigten Microsoft-Graph-Berechtigungen (Mail, Kalender, Kontakte, Aufgaben) sind jetzt vollständig aufgelistet' },
    ],
  },
  {
    version: '1.10.6',
    date: '2026-05-18T12:00:00',
    title: 'CPC-Kalkulator: Alle Anzeigeprobleme bei älteren Kalkulationen behoben',
    items: [
      { type: 'fix', text: 'CPC-Kalkulator: Ältere Kalkulationen öffnen jetzt fehlerfrei — fehlende Felder (Faktoren, PT-Werte) werden mit Standardwerten aufgefüllt statt einen Fehler auszulösen' },
    ],
  },
  {
    version: '1.10.5',
    date: '2026-05-18T10:00:00',
    title: 'CPC-Kalkulator: Fehler behoben & Voraussetzung klargestellt',
    items: [
      { type: 'fix', text: 'CPC-Kalkulator: Fehler beim Öffnen älterer Kalkulationen behoben (Schätzunsicherheit konnte nicht gelesen werden)' },
      { type: 'improvement', text: 'CPC-Kalkulator: Tab ist deaktiviert solange kein Compliance-Profil angelegt wurde — Tooltip erklärt warum' },
    ],
  },
  {
    version: '1.10.4',
    date: '2026-05-17T11:00:00',
    title: 'Website-Links in Unternehmen & Kontakten repariert',
    items: [
      { type: 'fix', text: 'Unternehmen & Kontakte: Website-Links ohne „https://" öffnen jetzt korrekt die externe Seite — vorher wurde die Adresse fälschlicherweise als interner Pfad interpretiert' },
    ],
  },
  {
    version: '1.10.3',
    date: '2026-05-17T10:00:00',
    title: 'Versionshistorie komprimiert',
    items: [
      { type: 'improvement', text: '„Was ist neu?": Die letzten 3 Versionen werden ausführlich angezeigt, ältere Versionen erscheinen komprimiert als Liste' },
    ],
  },
  {
    version: '1.10.1',
    date: '2026-05-16T12:00:00',
    title: 'Compliance-Profil: Löschen möglich',
    items: [
      { type: 'feature', text: 'Compliance-Profil: „Löschen"-Button im Unternehmensprofil — nach Bestätigung wird das gesamte Profil unwiderruflich entfernt' },
    ],
  },
  {
    version: '1.10.0',
    date: '2026-05-16T10:00:00',
    title: 'Sortierung: Groß-/Kleinschreibung ignoriert',
    items: [
      { type: 'fix', text: 'Unternehmen und Kontakte: Alphabetische Sortierung funktioniert jetzt auch bei gemischter Groß- und Kleinschreibung korrekt — „abc GmbH" erscheint jetzt zwischen „A" und „B", nicht mehr am Ende der Liste' },
    ],
  },
  {
    version: '1.9.9',
    date: '2026-05-15T14:00:00',
    title: 'Unternehmen & Kontakte wieder ladbar',
    items: [
      { type: 'fix', text: 'Unternehmen und Kontakte konnten nicht mehr geladen werden — ein Sortierfehler im Backend ist jetzt behoben' },
    ],
  },
  {
    version: '1.9.8',
    date: '2026-05-15T13:00:00',
    title: 'Unternehmen & Kontakte wieder verfügbar',
    items: [
      { type: 'fix', text: 'Unternehmen und Kontakte wurden nach dem letzten Update nicht mehr geladen — ein interner Datenbankfehler ist jetzt behoben' },
    ],
  },
  {
    version: '1.9.6',
    date: '2026-05-15T12:00:00',
    title: 'Compliance-Profil: Speichern funktioniert wieder',
    items: [
      { type: 'fix', text: 'Compliance-Profil anlegen und speichern funktioniert jetzt korrekt — ein Datenbankfehler verhinderte bisher das Speichern' },
    ],
  },
  {
    version: '1.9.5',
    date: '2026-05-13T12:00:00',
    title: 'Unternehmensliste: sortierbar per Klick',
    items: [
      { type: 'improvement', text: 'CRM Unternehmen: Spaltenüberschriften „Name" und „Branche" anklicken zum Sortieren — Pfeil zeigt Richtung an' },
      { type: 'fix', text: 'Sortierung ignoriert jetzt Groß-/Kleinschreibung — Unternehmen mit Großbuchstaben werden nicht mehr ans Ende sortiert' },
    ],
  },
  {
    version: '1.9.4',
    date: '2026-05-12T12:00:00',
    title: 'PDF-Export: Zeilenumbrüche & neue Branche',
    items: [
      { type: 'fix', text: 'Experten-Profil PDF & Word-Export: Zeilenumbrüche im Aufgabenfeld werden jetzt korrekt dargestellt — Leerzeilen als Abstand, nicht weggefiltert' },
      { type: 'feature', text: 'Neue Branche im Experten-Profil: „Schiffsbau / Defense"' },
    ],
  },
  {
    version: '1.9.3',
    date: '2026-05-11T16:00:00',
    title: 'Zeichenzähler korrigiert',
    items: [
      { type: 'fix', text: 'Experten-Profil: Zeichenzähler im Aufgabenfeld zeigt jetzt korrekt „/ 3.000" an (vorher fälschlicherweise „/ 1.500")' },
    ],
  },
  {
    version: '1.9.2',
    date: '2026-05-11T12:00:00',
    title: 'Mehr Platz für Projektbeschreibungen',
    items: [
      { type: 'improvement', text: 'Experten-Profil: Aufgabenfeld in Projekten fasst jetzt bis zu 3.000 Zeichen (vorher 1.500)' },
    ],
  },
  {
    version: '1.9.1',
    date: '2026-05-05T12:00:00',
    title: 'Alphabetische Sortierung in Kontakten & Unternehmen',
    items: [
      { type: 'fix', text: 'Kontakte: Liste wird jetzt immer alphabetisch nach Nachname sortiert' },
      { type: 'fix', text: 'Unternehmen: Liste wird jetzt immer alphabetisch nach Name sortiert' },
    ],
  },
  {
    version: '1.9.0',
    date: '2026-05-05T10:00:00',
    title: 'Gesellschaft-Zuordnung & Website-Validierung',
    items: [
      { type: 'feature', text: 'Unternehmen: „Gesellschaft" — Zuordnung zu internen Gesellschaften (z.B. Xinion Holding, Xinion IT) jetzt möglich' },
      { type: 'fix', text: 'Unternehmen speichern: Website-Adressen ohne „https://" (z.B. www.firma.de) werden jetzt akzeptiert' },
      { type: 'fix', text: 'Unternehmen bearbeiten: Validierungsfehler beim Speichern behoben' },
    ],
  },
  {
    version: '1.8.3',
    date: '2026-05-04T16:00:00',
    title: 'Anmeldung stabilisiert',
    items: [
      { type: 'fix', text: 'Anmeldung: Korrekt eingegebene Passwörter werden jetzt immer akzeptiert — auch nach mehreren Fehlversuchen' },
      { type: 'fix', text: 'Anmeldung: Login funktioniert zuverlässig auch nach einem Server-Neustart' },
    ],
  },
  {
    version: '1.8.2',
    date: '2026-05-04T14:00:00',
    title: 'Experten-Profile: Skills korrekt angezeigt',
    items: [
      { type: 'fix', text: 'Experten-Profile: Skills & Kompetenzen werden jetzt auf der Detailseite korrekt als Blasen angezeigt — Altdaten aus einer früheren Version wurden bereinigt' },
    ],
  },
  {
    version: '1.8.1',
    date: '2026-05-04T10:00:00',
    title: 'Outlook-Kontakte & Visitenkarten-Scanner',
    items: [
      { type: 'fix', text: 'Outlook-Kontakte: Namen von neu angelegten Kontakten werden jetzt korrekt angezeigt — fehlende Namen werden aus Vor-/Nachname oder E-Mail-Adresse ergänzt' },
      { type: 'feature', text: 'Visitenkarten-Scanner: vollständig neu — Foto hochladen oder Kamera öffnen, Text wird automatisch erkannt und die Felder vorausgefüllt' },
      { type: 'fix', text: 'Account Owner: bei Neuanlage eines Unternehmens werden jetzt alle verfügbaren Benutzer angezeigt' },
      { type: 'improvement', text: 'Beschreibungsfeld bei Aktivitäten: jetzt mit Formatierungs-Editor (Fett, Kursiv, Listen)' },
    ],
  },
  {
    version: '1.8.0',
    date: '2026-05-03T10:00:00',
    title: 'CRM – Messe-Optimierung & neue Aktivitätstypen',
    items: [
      { type: 'feature', text: 'Aktivitäten: neue Typen Termin, Social Media, Messenger und Event – Teilnahme direkt auswählbar' },
      { type: 'feature', text: 'Aktivität erfassen: neues übersichtliches Formular mit zwei Spalten — bei Anrufen Ergebnis & Dauer, bei Terminen/Events Ort und Teilnehmer direkt eintragen' },
      { type: 'feature', text: '„Speichern & Neu": nach dem Speichern bleibt das Formular offen — ideal für die schnelle Erfassung vieler Gespräche auf der Messe' },
      { type: 'feature', text: 'Vertrieb & Projekte: drei Reiter — Anfragen, Aktuelle Projekte, Abgeschlossene Projekte — mit Zähler-Badges' },
      { type: 'improvement', text: 'Release-Hinweis zeigt jetzt neben dem Datum auch die genaue Uhrzeit' },
    ],
  },
  {
    version: '1.7.0',
    date: '2026-05-02',
    title: 'Vertrieb & Projekte — neues Projektzentrum',
    items: [
      { type: 'feature', text: 'Projekte (ehem. Projektanfragen): jede Zeile aufklappbar — Aktivitätsverlauf, Angebote & Clockodo-Projektbericht direkt inline' },
      { type: 'feature', text: 'ERP Belege direkt am Projekt zuordnen: Angebote & Auftragsbestätigungen links, Rechnungen rechts unter dem Clockodo-Projektbericht' },
      { type: 'improvement', text: 'Vertrieb & Projekte: übersichtlicheres 2-Spalten-Layout — Projekte links, Verträge rechts' },
    ],
  },
  {
    version: '1.6.0',
    date: '2026-05-02',
    title: 'Compliance-Profil & Aufräumarbeiten',
    items: [
      { type: 'improvement', text: 'Compliance-Profil bearbeiten: Felder jetzt übersichtlich untereinander — kein klobiges Tabellenraster mehr' },
      { type: 'improvement', text: 'Datenqualitäts-Badge (Standard / Geschätzt / Bekannt) jetzt farbig direkt neben dem Feldnamen — anklicken zum Wechseln' },
    ],
  },
  {
    version: '1.5.0',
    date: '2026-05-02',
    title: 'CRM & Plattform Update',
    items: [
      { type: 'feature', text: '„Was ist neu?" — Nach jedem Update sehen Sie beim nächsten Anmelden auf einen Blick, was sich geändert hat' },
      { type: 'feature', text: 'Unternehmensprofil: Kontakthistorie mit „Neue Aktivität"-Button, kompakter Filterleiste und klickbaren Einträgen' },
      { type: 'feature', text: 'Unternehmensprofil: Vertrieb & Projekte jetzt übersichtlich in zwei Spalten — Projektanfragen & Clockodo links, Verträge & ERP rechts' },
      { type: 'feature', text: 'Kontaktprofil: Kontaktdaten, Berufliches und System-Details stehen jetzt nebeneinander — übersichtlicher auf einen Blick' },
      { type: 'improvement', text: 'Compliance Profil: IT-Reifegrad zeigt jetzt alle vier Bereiche (ISMS, BCMS, Zertifizierungen, Audit) einzeln mit Punktestand und Fortschrittsbalken' },
      { type: 'improvement', text: 'Clockodo: Zeiterfassung wird jetzt zuverlässiger den richtigen Projekten zugeordnet' },
      { type: 'fix', text: 'CPC: Versionsnummer der Kalkulation wird jetzt korrekt ohne doppeltes „v" angezeigt' },
      { type: 'fix', text: 'Clockodo: Fehlermeldung bei nicht konfigurierter Verbindung wird jetzt korrekt angezeigt' },
    ],
  },
  {
    version: '1.4.0',
    date: '2026-04-28',
    title: 'UI Redesign Sprint 6',
    items: [
      { type: 'feature', text: 'Unternehmensprofil komplett überarbeitet: neues Tab-Layout, Compliance-Bereich, Kontakte-Tab' },
      { type: 'improvement', text: 'Dark Mode Verbesserungen in allen CRM-Komponenten' },
    ],
  },
];

export const LATEST_RELEASE = RELEASE_NOTES[0];
